export default "__VITE_ASSET__Drsai4Ax__"